import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// action creators
import { doctorDelete } from '../../../actions/doctorActions';
import { tooltipHide, tooltipShow } from '../../../actions/tooltipActions';

// components
import EditDoctorTooltip from './_EditDoctorTooltip';
import { Button } from '../../shared/_form';
import Modal from '../../shared/_Modal';

class IndexRow extends React.Component {
  static propTypes = {
    deleteDoctor: PropTypes.func.isRequired,
    doctor:       PropTypes.instanceOf(Immutable.Map),
    hideModal:    PropTypes.func.isRequired,
    showModal:    PropTypes.func.isRequired
  }

  render() {
    const { doctor } = this.props;

    return (
      <div className='manager__doctor-index__table__row' key={ doctor.get('id') }>
        <div className='manager__doctor-index__table__doctor-name'>
          { doctor.get('name') }
        </div>
        <div className='manager__doctor-index__table__doctor-days-in'>
          { this._renderWeeklySchedule() || '-' }
        </div>
        <div className='manager__doctor-index__table__doctor-email'>
          { doctor.get('email') || '-' }
        </div>
        <div className='manager__doctor-index__table__actions'>

          <EditDoctorTooltip doctor={ doctor } />
          <i className='manager__doctor-index__table__action fa fa-trash-o' onClick={ this._handleShowDeleteDoctorModal } />
          <Modal header='Delete Doctor' id={ this._getModalId() }>
            Are you sure you would like to delete <strong>{ doctor.get('name') }</strong>
            <div className='modal__actions'>
              <Button className='form__button form__button--purple' onClick={ this._handleCloseDeleteDoctorModal } type='button'>Cancel</Button>
              <Button className='form__button form__button--green' onClick={ this._handleDeleteDoctor } type='button'>Yes</Button>
            </div>
          </Modal>
        </div>
      </div>
    );
  }

  // private

  _handleCloseDeleteDoctorModal = this._handleCloseDeleteDoctorModal.bind(this);
  _handleDeleteDoctor           = this._handleDeleteDoctor.bind(this);
  _handleShowDeleteDoctorModal  = this._handleShowDeleteDoctorModal.bind(this);

  _getModalId() {
    const { doctor } = this.props;

    return `deleteDoctorModal${doctor.get('id')}`;
  }

  _handleCloseDeleteDoctorModal() {
    const { hideModal } = this.props;

    hideModal(this._getModalId());
  }

  _handleDeleteDoctor() {
    const { deleteDoctor, doctor } = this.props;

    deleteDoctor(doctor.toJS());
    this._handleCloseDeleteDoctorModal();
  }

  _handleShowDeleteDoctorModal() {
    const { showModal } = this.props;

    showModal(this._getModalId());
  }

  _renderWeeklySchedule() {
    const weeklySchedule = [];
    const { doctor } = this.props;

    const currentWeeklySchedule = doctor.get('currentWeeklySchedule') || Immutable.Map();

    if (currentWeeklySchedule.get('monday')) weeklySchedule.push('Mondays');
    if (currentWeeklySchedule.get('tuesday')) weeklySchedule.push('Tuesdays');
    if (currentWeeklySchedule.get('wednesday')) weeklySchedule.push('Wednesdays');
    if (currentWeeklySchedule.get('thursday')) weeklySchedule.push('Thursdays');
    if (currentWeeklySchedule.get('friday')) weeklySchedule.push('Fridays');

    return weeklySchedule.join(', ');
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    deleteDoctor: (params) => {
      dispatch(doctorDelete(params));
    },

    hideModal: (id) => {
      dispatch(tooltipHide({ id: id }));
    },

    showModal: (id) => {
      dispatch(tooltipShow({ id: id }));
    }
  };
};

export default connect(null, mapDispatchToProps)(IndexRow);



// WEBPACK FOOTER //
// ./app/components/managers/doctors/_IndexRow.jsx